export enum DelayType 
{
	OnEnd = "onEnd",
	OnPlay = "onPlay"
}